import React, { forwardRef } from "react";
import "./Cards.scss";
import InvoiceImage from "../../../assets/images/InvoiceResized.webp";
import FeatureCard from "./FeatureCard.jsx";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 600);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isMobile;
};

const FeaturesCards = forwardRef(({ cardsRef }, ref) => {
  const isMobile = useIsMobile();

  // Example cards data
  const cards = [
    {
      title: "Automated Payments using Mpesa",
      description:
        "Enable seamless rent collection with automated Mpesa payments. Tenants pay easily, and you get notified instantly.",
      gradientRotation: isMobile ? "0deg" : "90deg",
      imageUrl: InvoiceImage,
      className: isMobile ? "short-card" : "long-card",
      overlayClass: isMobile ? "short-card-overlay" : "long-card-overlay",
    },
    {
      title: "SMS Reminders",
      description:
        "Send timely SMS reminders to tenants for upcoming rent payments, ensuring you never miss a due date.",
      gradientRotation: "0deg",
      imageUrl: InvoiceImage,
      className: "short-card",
      overlayClass: "short-card-overlay",
    },
    {
      title: "Invoice Generation",
      description:
        "Quickly generate professional invoices for your rental properties and share them with tenants in just a few clicks.",
      gradientRotation: "0deg",
      imageUrl: InvoiceImage,
      className: "short-card",
      overlayClass: "short-card-overlay",
    },
    {
      title: "Expense Tracking",
      description:
        "Track property-related expenses efficiently. Categorize, monitor, and analyze your spending to maximize profits.",
      gradientRotation: isMobile ? "0deg" : "270deg",
      imageUrl: InvoiceImage,
      className: isMobile ? "short-card" : "long-card",
      overlayClass: isMobile ? "short-card-overlay" : "long-card-overlay-270",
    },
  ];

  if (isMobile) {
    // All cards are short cards, render in a single column
    return (
      <div className="features-cards">
        {cards.map((card, idx) => (
          <FeatureCard
            key={idx}
            {...card}
            ref={(el) => (cardsRef.current[idx] = el)}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="features-cards">
      <FeatureCard {...cards[0]} ref={(el) => (cardsRef.current[0] = el)} />
      <div className="short-card-container">
        <FeatureCard {...cards[1]} ref={(el) => (cardsRef.current[1] = el)} />
        <FeatureCard {...cards[2]} ref={(el) => (cardsRef.current[2] = el)} />
      </div>
      <FeatureCard {...cards[3]} ref={(el) => (cardsRef.current[3] = el)} />
    </div>
  );
});

export default FeaturesCards;
